import { memo } from "react"
import { IconStackPerspectiveOutline18 as StackPerspectiveIcon } from "nucleo-ui-outline-18"

import type { ChangelogVersion } from "@productlane/zero"

import type { CoverRow } from "./changelog-cover"
import type { VersionAuthorUser } from "@/components/version-author"
import { VersionHistoryDialog as VersionHistoryDialogBase } from "@/components/version-history/version-history-dialog"
import { coverBlurhashFor } from "./changelog-cover"
import { ChangelogPreview } from "./changelog-preview"

export type ChangelogVersionRow = ChangelogVersion & {
	createdBy?: VersionAuthorUser | null
}

interface VersionHistoryDialogProps {
	isOpen: boolean
	onOpenChange: (open: boolean) => void
	onRestore: (version: ChangelogVersionRow) => void
	versions: readonly ChangelogVersionRow[]
	isLoading?: boolean
	changelogTitle: string
	/** The live covers, whose hash a version reuses when it shows the same file. */
	coverRows?: readonly CoverRow[]
}

export const VersionHistoryDialog = memo(
	({
		isOpen,
		onOpenChange,
		onRestore,
		versions,
		isLoading,
		changelogTitle,
		coverRows = [],
	}: VersionHistoryDialogProps) => (
		<VersionHistoryDialogBase
			isOpen={isOpen}
			onOpenChange={onOpenChange}
			versions={versions}
			isLoading={isLoading}
			entityName={
				<span className="flex min-w-0 items-center gap-1.5">
					<StackPerspectiveIcon className="h-4 w-4 shrink-0 text-secondary" />
					<span className="truncate">{changelogTitle || "New changelog"}</span>
				</span>
			}
			emptyText="Versions appear here as you save changes to this changelog."
			renderPreview={(version) => (
				<ChangelogPreview
					version={version}
					key={version.id}
					blurhash={coverBlurhashFor(version.imageUrl, [...coverRows])}
				/>
			)}
			onRestore={onRestore}
		/>
	),
)

VersionHistoryDialog.displayName = "VersionHistoryDialog"
